// =====================================================================
// My Agency V2 — tab chrome (ARTBOARD-SPEC §4 CMP-TABS).
//
// Row: flex gap 26 (mobile 20), bottom border #E3E9F1. Active item:
// 600 #0F172A + 2px brand underline (margin-bottom -1 overlaps the row
// border). Count pill optional — counts come from EXISTING loaded state
// only (no new count endpoints, Rule 8); pass `count: null/undefined`
// to hide the pill for tabs whose data hasn't loaded.
//
// `right` slot hosts the per-tab action button (tabs+action row per
// board 4a).
//
// W1-05 — the row border is an INSET SHADOW, not `border-b`, and every
// tab carries a full-height 2px bottom border (transparent when
// inactive) with NO negative margin. The old `-mb-px` overlap trick made
// the active tab's border box 1px taller than the `overflow-x-auto`
// scroll container, so the strip grew its own scrollbar (`overflow-x`
// coerces `overflow-y` to auto). With nothing overflowing, the strip
// sits fixed; horizontal scrolling still kicks in only when the tabs
// genuinely don't fit (narrow/mobile). The active underline still paints
// over the grey row line — the shadow's bottom pixel and the border's
// bottom pixel share the same row.
// =====================================================================
import React from "react";
import { CountPill } from "./pills";

const TabBar = ({ tabs = [], activeKey, onChange, mobile = false, right, className = "", style, ...rest }) => (
  <div
    className={`flex items-center shadow-[inset_0_-1px_0_#E3E9F1] font-tpv2 ${className}`}
    style={style}
    {...rest}
  >
    <div className={`flex flex-1 min-w-0 overflow-x-auto ${mobile ? "gap-5" : "gap-[26px]"}`}>
      {tabs.map((t) => {
        const active = t.key === activeKey;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange && onChange(t.key)}
            className={[
              "flex items-center bg-transparent border-0 border-b-2 border-solid cursor-pointer whitespace-nowrap",
              mobile ? "gap-1.5 pt-[7px] pb-[9px] px-0.5 text-[13.5px]" : "gap-[7px] pt-[9px] pb-[11px] px-0.5 text-sm",
              active
                ? "font-semibold text-[#0F172A] border-b-[#2283FF]"
                : "font-medium text-[#64748B] border-b-transparent hover:text-[#0F172A]",
            ].join(" ")}
          >
            {t.label}
            {t.count != null && (
              <CountPill variant={active ? "active" : "inactive"} mobile={mobile}>
                {t.count}
              </CountPill>
            )}
          </button>
        );
      })}
    </div>
    {right && <div className="flex-none pl-4">{right}</div>}
  </div>
);

export default TabBar;
